import React from 'react';
import PropTypes from 'prop-types';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import { translate } from 'helpers/translateHelper';
import './_style.scss';
// Helper function to get the title based on error code
const getErrorTitle = (code) => {
    switch (code) {
        case 400:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitle400');
        case 401:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitle401');
        case 403:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitle403');
        case 404:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitle404');
        case 500:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitle500');
        case 502:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitle502');
        case 503:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitle503');
        case 504:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitle504');
        default:
            return translate('ABB.Powertrain.Frontend.errorBoundaryMessageTitleUnknown');
    }
};
const ErrorView = ({ errorCode, errorMessage, onRetry, onReportIssue }) => {
    const handleRetry = () => {
        if (onRetry) {
            onRetry();
        } else {
            window.location.reload();
        }
    };

    return (
        <div className='error-container' data-error-code={errorCode}>
            <div className='error-content'>
                <div className='error-indicator-view'></div>
                <div className='error-header'>
                    <h1>{errorCode} {getErrorTitle(errorCode)}</h1>
                </div>
                <p className='error-message'>{errorMessage}</p>
                <div className='error-actions'>
                    <GeneralButton type='normal' text={translate('ABB.Powertrain.Frontend.erroBoundaryRetryLabel')} onClick={handleRetry} />
                    <GeneralButton type='normal' text={translate('ABB.Powertrain.Frontend.errorBoundaryContactLabel')} onClick={() => onReportIssue?.()} />
                </div>
            </div>
        </div>
    );
};

ErrorView.propTypes = {
    errorCode: PropTypes.number,
    errorMessage: PropTypes.string,
    onRetry: PropTypes.func,
    onReportIssue: PropTypes.func
};

export default ErrorView;
